<template>

    <section class="handins">
        <div class="panel">
            <div class="panel-heading"><h2>Hand-Ins</h2></div>
            <div class="panel-body">
            <ul class="list-group" v-if="handIns">
                <li v-for="handIn in handIns" class="list-group-item">
                    <h3>{{handIn.user.firstName}} {{handIn.user.lastName}}</h3>
                    <h4 :style="{'color' : assessmentColor(handIn.assessment)}">{{getAssessment(handIn.assessment)}}</h4>
                    <h5>Submitted on {{handIn.createdAt | longDate}}</h5>
                    <blockquote>{{handIn.comments}}</blockquote>
                    <div v-if="handIn.url && handIn.url.length > 0">
                        <a v-for="url in handIn.url" :href="url" class="btn btn-default" target="_blank">Download File</a>
                    </div>
                </li>
            </ul>
            </div>
        </div>
    </section>
</template>


<script>

    import exercises from '../services/exercises';
    import toastr from 'toastr';

    export default {
        data() {
            return {
                handIns: null,
                assessments: ['I\'m completely lost', 'I think I got it','I nailed it']
            }
        },
        mounted() {
            this.getHandIns(this.$route.params.exerciseId);
        },
        methods: {
            getHandIns(exerciseId) {
                
                var self = this;
                exercises.getHandIns(this, exerciseId).then(function(response) {
                    if (response.data.success === true) {
                        self.handIns = response.data.handins;
                    } else {
                        toastr.error('Error getting hand-ins');
                    }
                })
            },
            getAssessment(assessment) {
                return this.assessments[assessment - 1];
            },
            assessmentColor(assessment) {
                if (assessment == 1) {
                    return 'red';
                } else if (assessment == 2) {
                    return 'yellow';
                }
                return 'green';
            }
        }
    }
</script>

<style lang="scss" scoped>
h3 {
    font-size:2rem;
}
blockquote {
    font-size:1.6rem;
}
</style>


// WEBPACK FOOTER //
// HandIns.vue?7228316c